module.exports = __webpack_public_path__ + "987500cc8f4cdce9ce37920f571eda2a.svg";